import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {accreditationProfile} from '../../../../../services/session.service';
import { MatMenuItem } from '@angular/material/menu';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-accreditation-profile',
    templateUrl: './accreditation-profile.component.html',
    styleUrls: ['./accreditation-profile.component.scss'],
    imports: [MatMenuItem, RouterLinkActive, RouterLink, MatIcon]
})
export class AccreditationProfileComponent implements OnInit {

  @Input() profiles: accreditationProfile[];
  @Input() annualUpdate: boolean = false;
  @Output() closeMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {
  }
}
